import { useAccount } from './use-account'
import { RequestInit } from '@vercel/fetch'
import { SWRConfiguration } from 'swr'
import { Customer, CustomerAddress, Maybe } from '@pylot-data/fwrdschema'
import { GraphQLError } from '@pylot-data/graphqlFetch'

export const useUser = (
    swrOptions: SWRConfiguration = {},
    fetchOptions?: RequestInit
): {
    loading: boolean
    error: GraphQLError
    isSignedIn: boolean
    customer?: Customer
    addresses: Maybe<CustomerAddress>[]
    isSubscribed: boolean
    getAddressById: (id: number) => Maybe<CustomerAddress>[] | undefined
    getAddressByUid: (uid: string) => Maybe<CustomerAddress>[] | undefined
    mutate: () => Promise<any>
} => {
    const { data, error, isValidating, mutate } = useAccount(
        swrOptions,
        fetchOptions
    )
    const loading = !!(isValidating && !data)
    const isSignedIn = !error && data && !data.errors
    const customer = data?.data?.customer
    const addresses = customer?.addresses || []
    const isSubscribed = customer?.is_subscribed

    const getAddressById = (id: number) => {
        return addresses.filter((value) => {
            return value?.id === id
        })
    }

    const getAddressByUid = (uid: string) => {
        return addresses.filter((value) => {
            return value?.uid === uid
        })
    }

    return {
        loading,
        error,
        isSignedIn: !!isSignedIn,
        customer,
        addresses,
        isSubscribed: !!isSubscribed,
        getAddressById,
        getAddressByUid,
        mutate
    }
}
